import React, { useContext, useState } from 'react';
import './style.css';
import { TestStatusContext } from '/src/App';
// Helper function for formatting values (move this from UpdateDataModule if it exists there)
const formatValue = (value) => {
    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    }
    return value;
};

// DatapointChange sub-component
const DatapointChange = ({ change, onRemove }) => {
    if (change.type_for_user_form === 'project') {
        return (
            <div className="datapoint-change">
                <div className="datapoint-change-content">
                    <h4 className="datapoint-change-headline text-align-center">{change.project_name}</h4>
                    <div className="datapoint-change-values">
                        <span className="completed-status">Marked as Completed</span>
                    </div>
                </div>
                <button
                    className="remove-change-button"
                    onClick={() => onRemove(change.project_id, 'project')}
                >
                    REMOVE
                </button>
            </div>
        );
    }

    return (
        <div className="datapoint-change">
            <div className="datapoint-change-content">
                <h4 className="datapoint-change-headline text-align-center">{change.headline}</h4>
                <div className="datapoint-change-values">
                    <div className="value-change">
                        <span className="value-label">From:</span>
                        <span className="original-value">{formatValue(change.datapoint_value)}</span>
                        <span className="value-label">To:</span>
                        <span className="updated-value">{formatValue(change.datapoint_value_updated)}</span>
                    </div>
                </div>
            </div>
            <button
                className="remove-change-button"
                onClick={() => onRemove(change.id, 'datapoint')}
            >
                REMOVE
            </button>
        </div>
    );
};

// Main Sidebar component
const Sidebar = ({ 
    updatedDatapoints, 
    removeChange, 
    handleUpdateAnalysis, 
    processingStatus 
}) => {
    const { testStatus } = useContext(TestStatusContext);
    const [buttonHoverStatus, setButtonHoverStatus] = useState(false);
    console.log(testStatus)
    console.log(buttonHoverStatus)
    return (
        <div className="update-data-sidebar">
            <div className="update-data-changes">
                <h3>Changes Made ({updatedDatapoints.length})</h3>
                <div className="changes-list">
                    {updatedDatapoints.map(change => (
                        <DatapointChange
                            key={change.id}
                            change={change}
                            onRemove={removeChange}
                        />
                    ))}
                </div>
            </div>
            <div className={`update-data-actions ${testStatus ? 'demo-mode' : ''}`}>
                <button
                    className={`update-analysis-button ${(buttonHoverStatus && testStatus) ? 'demo-mode-hovered' : ''}`}
                    onClick={handleUpdateAnalysis}
                    disabled={testStatus}
                    onMouseOver={() => {
                        console.log('Mouse Over Event Fired');
                        setButtonHoverStatus(true);
                    }}
                    onMouseLeave={() => {
                        console.log('Mouse Leave Event Fired');
                        setButtonHoverStatus(false);
                    }}
                >
                    {testStatus ? (
                        buttonHoverStatus ? 'Create Account to Update' : 'Update Analysis'
                    ) : (
                        processingStatus ? 'Processing...' : 'Update Analysis'
                    )}
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
